import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { Box, Button, Callout, Flex, Link, Text, TextField } from "@radix-ui/themes";
import { type FormEvent, useState } from "react";

interface SignInFormProps {
    onSubmit: (data: any) => Promise<void>;
    loading: boolean;
    onForgotPassword?: () => void;
}

function SignInForm({ onSubmit, loading, onForgotPassword }: SignInFormProps) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError(null);
        try {
            await onSubmit({
                email,
                password,
            });
        } catch (err: any) {
            setError(err.message || "Failed to sign in");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Flex direction="column" gap="4">
                {error && (
                    <Callout.Root color="red" size="1">
                        <Callout.Icon>
                            <ExclamationTriangleIcon />
                        </Callout.Icon>
                        <Callout.Text>{error}</Callout.Text>
                    </Callout.Root>
                )}
                <Box>
                    <Text as="div" size="2" mb="1" weight="bold">
                        Email
                    </Text>
                    <TextField.Root
                        size="3"
                        disabled={loading}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="your.email@example.com"
                        autoComplete="username"
                        type="email"
                    />
                </Box>

                <Box>
                    <Flex justify="between" align="baseline" mb="1">
                        <Text as="div" size="2" weight="bold">
                            Password
                        </Text>
                    </Flex>
                    <TextField.Root
                        size="3"
                        disabled={loading}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        placeholder="Your password"
                        autoComplete="current-password"
                        type="password"
                    />
                </Box>

                <Button
                    type="submit"
                    size="3"
                    variant="soft"
                    loading={loading}
                    style={{
                        cursor: "pointer",
                    }}
                >
                    {loading ? "Signing in..." : "Sign In"}
                </Button>
                {onForgotPassword && (
                    <Link
                        href="#"
                        size="2"
                        onClick={(e) => {
                            e.preventDefault();
                            if (onForgotPassword) {
                                onForgotPassword();
                            }
                        }}
                        style={{
                            cursor: "pointer",
                            height: "auto",
                            alignSelf: "center",
                        }}
                    >
                        Forgot password?
                    </Link>
                )}
            </Flex>
        </form>
    );
}

export default SignInForm;
